// extracted by mini-css-extract-plugin
export var centerText = "_5q-8";
export var container = "_5q-0";
export var doughnutContainer = "_5q-7";
export var legend = "_5q-a";
export var legendItemColorDisplay = "_5q-b";
export var legendItemLabel = "_5q-d";
export var legendItemValue = "_5q-c";
export var lg = "_5q-5";
export var maxWidth = "_5q-9";
export var md = "_5q-4";
export var responsive = "_5q-6";
export var sm = "_5q-3";
export var xs = "_5q-2";
export var xxs = "_5q-1";